<template>
	<popover className="login-popover" ref="loginPopover" :isError="isError">
		<div>
			{{ reason || 'You need to be logged in to continue.' }}
			Log in now?

			<div class="buttons">
				<button class="login-cancel-button" @click.prevent="clickedCancelButton">Cancel</button>
				<button class="login-slack-button" @click.prevent="clickedLoginButton">Sign In</button>
			</div>
		</div>
	</popover>
</template>


<script>
	import Popover from './Popover.vue'
	import CustomPopover from '@/mixins/custom-popover'

	export default {
		name: 'login-popover',
		props: {
			reason: String,
			isError: Boolean,
			prevRoute: String
		},
		mixins: [ CustomPopover ],
		components: { Popover },
		methods: {
			clickedCancelButton() {
				this.$refs.loginPopover.close()
				
				if (this.isError) {
					if (this.prevRoute) {
						this.$router.back()
					} else {
						this.$router.push('/')
					}
				}
			},
			clickedLoginButton() {
				this.$refs.loginPopover.close()
				window.location = this.$store.getters.loginUrl
			}
		}
	}
</script>


<style lang="scss">
	
	.login-popover {
		
	}

</style>
